module.exports = __webpack_public_path__ + "img/Oval(1)_個人星盤.ac35578d.svg";